import { render, staticRenderFns } from "./__detail_prescription.vue?vue&type=template&id=fb6addca&scoped=true&"
import script from "./__detail_prescription.vue?vue&type=script&lang=js&"
export * from "./__detail_prescription.vue?vue&type=script&lang=js&"
import style0 from "./__detail_prescription.vue?vue&type=style&index=0&id=fb6addca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6addca",
  null
  
)

export default component.exports